import { CSSProperties, FC, useState } from "react";

/**
 * Renders a branding asset without trusting any is-video flag or file extension:
 * it renders an <img> and, if the browser can't decode the fetched bytes as an
 * image, falls back to a <video>. The image decoder is the inspector, so a
 * mislabeled extension/Content-Type can't cause the wrong element.
 */
export const BrandingMedia: FC<{
  url: string;
  alt?: string;
  style?: CSSProperties;
}> = ({ url, alt, style }) => {
  const [isVideo, setIsVideo] = useState(false);

  if (isVideo) {
    return <video src={url} style={style} autoPlay loop muted playsInline />;
  }
  return (
    <img
      src={url}
      alt={alt ?? ""}
      style={style}
      onError={() => setIsVideo(true)}
    />
  );
};

export default BrandingMedia;
